import type { AppRouter } from './rest/helpers';
import type { Narrow } from './rest/type.utils';

export { createRESTClient } from './rest/client';
export type { TRESTServer } from './rest/server';
export { createRESTServer } from './rest/server';

// TODO: Credit ts-rest (https://ts-rest.com / https://github.com/ts-rest/ts-rest)

/**
 * Instantiate a ts-rest contract to supply to client and server
 */
export const createRESTContract = <T extends AppRouter>(entries: Narrow<T>) =>
  entries;
